import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-panel-toggle',
  templateUrl: './panel-toggle.component.html',
  styleUrls: ['./panel-toggle.component.scss'],
  imports: [CommonModule, MatTooltip]
})
export class PanelToggleComponent {
  @Input({ required: true }) readonly icon: string;
  @Input() readonly label: string;
  @Input({ required: true }) toggleState: boolean;
  @Input() readonly tooltip: string;
  @Output() togglePanel = new EventEmitter<boolean>();

  constructor() {}

  onToggleClick(): void {
    this.toggleState = !this.toggleState;
    this.togglePanel.emit(this.toggleState);
  }
}
